import { render, staticRenderFns } from "./TopicEditor.vue?vue&type=template&id=b311b928&"
import script from "./TopicEditor.vue?vue&type=script&lang=js&"
export * from "./TopicEditor.vue?vue&type=script&lang=js&"
import style0 from "./TopicEditor.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports